import { z } from 'zod';

import { getLocale, zipValidation, zipValidationUSandCA } from '@libs/core';

import {
    cityRequiredMsg,
    genericZipInvalidMsg,
    stateRequiredMessages,
    streetAddressRequiredMsg,
    zipInvalidMessages,
    zipRequiredMessages,
} from './validationErrors';

const createZipCodeSchema = (validator: (val: string) => boolean, customErrorMsg?: string) =>
    z
        .string()
        .trim()
        .min(1, zipRequiredMessages[getLocale()])
        .refine(val => validator(val), {
            message: customErrorMsg ?? zipInvalidMessages[getLocale()],
        });

const citySchema = z.string().trim().min(1, cityRequiredMsg);
const streetAddressSchema = z.string().trim().min(1, streetAddressRequiredMsg);

const stateSchema = z.string().trim().min(1, stateRequiredMessages[getLocale()]);

export const addressFormSchema = z.object({
    streetAddress: streetAddressSchema,
    apt: z.optional(z.string().trim()),
    zipCode: createZipCodeSchema(zipValidation),
    state: stateSchema,
    city: citySchema,
});

export const addressFormSchemaUSandCA = addressFormSchema.extend({
    zipCode: createZipCodeSchema(zipValidationUSandCA, genericZipInvalidMsg),
});

export type AddressFormType = z.infer<typeof addressFormSchema>;

export type AddressFormTypeUSandCA = z.infer<typeof addressFormSchemaUSandCA>;
